function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-41daa99a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LinkHistoricoAlteracoes.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LinkHistoricoAlteracoes.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-41daa99a\",\"hasScoped\":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LinkHistoricoAlteracoes.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41daa99a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/website/historico-alteracoes/components/LinkHistoricoAlteracoes.vue
// module id = 1335
// module chunks = 17